<template>
  <d2-container>
    <el-form :model="form" :rules="rules" ref="form" label-width="190px">
      <el-form-item label="选中图标(最大不能超过2M)">
        <el-upload
          style="position: relative"
          class="avatar-uploader"
          :action="uploadUrl"
          accept="image/jpeg, image/gif, image/png, image/bmp"
          list-type="picture-card"
          :limit="1"
          :data="uploadData"
          :on-success="handleAvatarSuccess"
          :on-error="uploadError"
          :before-upload="beforeAvatarUpload"
          :file-list="fileList"
        >
          <i class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <el-form-item label="图标(最大不能超过2M)">
        <el-upload
          style="position: relative"
          class="avatar-uploader"
          :action="uploadUrl"
          accept="image/jpeg, image/gif, image/png, image/bmp"
          list-type="picture-card"
          :limit="1"
          :data="uploadData"
          :on-success="handleCommonIcon"
          :on-error="uploadError"
          :before-upload="beforeAvatarUpload"
          :file-list="fileList1"
        >
          <i class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <el-form-item label="类型" prop="type">
        <el-select class="filter-item" v-model="form.type" placeholder="请选择" @change="selectType">
          <el-option
            v-for="item in typeList"
            :key="item.index"
            :label="item.name"
            :value="item.index"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入名称" style="width: 217px"></el-input>
      </el-form-item>
      <el-form-item label="状态" prop="type">
        <el-select
          class="filter-item"
          v-model="form.status"
          placeholder="请选择"
          @change="selectStatus"
        >
          <el-option
            v-for="item in statusList"
            :key="item.index"
            :label="item.name"
            :value="item.index"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="展示方式" prop="showType">
        <el-select
          class="filter-item"
          v-model="form.showType"
          placeholder="请选择"
          @change="selectShowType"
        >
          <el-option
            v-for="item in showTypeList"
            :key="item.index"
            :label="item.name"
            :value="item.index"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label>
        <!-- <el-radio-group v-model="radio">
          <el-radio :label="6">产品详情</el-radio>
        </el-radio-group>-->
        <!-- <el-button type="primary" @click="getCommodity" >选择商品</el-button>
        <el-button type="danger" @click="batchDelete" >批量删除</el-button>-->
        <!-- <el-table
          size="small"
          :key="tableKey"
          :data="multipleSelection"
          ref="deleteTable"
          stripe
          border
          highlight-current-row
          style="max-width: 1428px; margin-top: 20px"
          @selection-change="handleDeleteChange"
          @cell-dblclick="tableDbEdit"

        >
          <el-table-column
            align="center"
            label
            width="180"
            type="selection"
          ></el-table-column>
          <el-table-column align="center" label="id" width="180">
            <template slot-scope="scope">
              <span>{{ scope.row.spuId }}</span>
            </template>
          </el-table-column>
          <el-table-column width="340" align="center" label="商品名称">
            <template slot-scope="scope">
              <span>{{ scope.row.spuName }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="展示图">
            <template slot-scope="scope">
              <el-upload
                style="position: relative"
                class="avatar-uploader"
                :action="uploadUrl"
                accept="image/jpeg, image/gif, image/png, image/bmp"
                list-type="picture-card"
                :limit="1"
                :data="uploadData"
                :on-success="
                  function (response, file) {
                    handleTablePic(response, file, scope.row);
                  }
                "
                :on-remove="
                  function (response, file, filelist) {
                    handleRemove(file, filelist, scope.row);
                  }
                "
                :on-error="uploadError"
                :before-upload="beforeAvatarUpload"
                :file-list="scope.row.fileListTable"
                ref="uploadMaterialFile"
              >
                <i class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </template>
          </el-table-column>
          <el-table-column width="180" align="center" label="排序">
            <template slot-scope="scope">
              <span>{{ scope.row.sort }}</span>
            </template>
          </el-table-column>
        </el-table>-->
      </el-form-item>
      <div v-for="(item,index) in form.articleLists" :key="index">
        <el-form-item label="排序" :prop="'articleLists.'+index+'.sort'" :rules="rules.sort" >
          <el-input v-model="item.sort" placeholder="请输入排序" style="width: 217px"></el-input>
        </el-form-item>
        <el-form-item label="名称" :prop="'articleLists.'+index+'.name'" :rules="rules.name" >
          <el-input v-model="item.name" placeholder="请输入名称" style="width: 217px"></el-input>
        </el-form-item>
        <el-form-item label="封面图" :prop="'articleLists.'+index+'.img'" :rules="rules.img" ref="image">
          <el-upload
            style="position: relative"
            class="avatar-uploader"
            :action="uploadUrl"
            accept="image/jpeg, image/gif, image/png, image/bmp"
            list-type="picture-card"
            :limit="1"
            :data="uploadData"
            :on-success="function (response, file) {handleCoverSuccess(response, file,item, index)}"
            :on-error="uploadError"
            :on-change="onChange"
            :before-upload="beforeAvatarUpload"
            :file-list="item.fileListCover"
          >
            <i class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="跳转地址" required>
          <jumpType2 :Jumpurls="item.Jumpurl"></jumpType2>
        </el-form-item>
        <div class="tc mb-20">
          <el-button
            type="danger"
            size="mini"
            @click="removeList(index)"
            v-if="index !== 0"
          >-删除产品</el-button>
          <el-button type="primary" size="mini" @click="addList" >+增加产品</el-button>
        </div>
      </div>
    </el-form>
    <div class="footer">
      <el-button @click="cancel('form')">取 消</el-button>
      <el-button type="primary" @click="getCreate('form')">确 定</el-button>
    </div>
    <el-dialog
      :visible.sync="dialogFormData"
      title="商品选择器"
      center
      width="1456px"
      :show-close="false"
      :close-on-click-modal="false"
    >
      <!-- <template slot="header"> -->
      <el-input
        @keyup.enter.native="getSearch"
        style="width: 200px; margin-right: 20px"
        class="filter-item"
        placeholder="请输入商品标题"
        size="small"
        v-model="listQuery.keyword"
      ></el-input>
      <el-button @click="getSearch" class="filter-item" type="primary" icon="search" size="small">搜索</el-button>
      <el-button @click="getReset" class="filter-item" icon="search" size="small">重置</el-button>
      <!-- </template> -->
      <el-table
        @row-click="clickRow"
        size="small"
        :key="tableKey"
        :data="list"
        ref="multipleTable"
        stripe
        border
        highlight-current-row
        style="  margin-top: 20px"
        @selection-change="handleSelectionChange"
      >
        <el-table-column align="center" label width="180" type="selection"></el-table-column>
        <el-table-column align="center" label="id" width="160">
          <template slot-scope="scope">
            <span>{{ scope.row.id }}</span>
          </template>
        </el-table-column>
        <el-table-column width="340" align="center" label="商品标题">
          <template slot-scope="scope">
            <span>{{ scope.row.title }}</span>
          </template>
        </el-table-column>
        <el-table-column width="245" align="center" label="副标题">
          <template slot-scope="scope">
            <span>{{ scope.row.viceTitle }}</span>
          </template>
        </el-table-column>
        <el-table-column width="160" align="center" label="商品封面">
          <template slot-scope="scope">
            <img :src="scope.row.cover" style="width: 80px; height: 80px; object-fit: cover" />
          </template>
        </el-table-column>
        <el-table-column width="140" align="center" label="出售价">
          <template slot-scope="scope">
            <span>{{ scope.row.price }}</span>
          </template>
        </el-table-column>
        <el-table-column width="180" align="center" label="市场价">
          <template slot-scope="scope">
            <span>{{ scope.row.maxPrice }}</span>
          </template>
        </el-table-column>
      </el-table>
      <!-- 页码 -->
      <template slot="footer">
        <div
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
          "
        >
          <div
            style="
              display: flex;
              width: 200px;
              font-size: 14px;
              align-items: center;
            "
          >
            最多可选
            <div style="color: red; margin: 0 15px">无限制</div>已选：
            <div style="color: red; margin-top: 2px">{{ number }}</div>
          </div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="listQuery.currentPage"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="listQuery.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            style="width: 500px"
          ></el-pagination>
          <div style="width: 155px">
            <el-button @click="getRem()">取 消</el-button>
            <el-button @click="getData()" type="primary">确定</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </d2-container>
</template>

<script>
import { mapGetters } from 'vuex'
import { getClassificationd, getToken } from '@/api/demo/classification/index'
import { getSpuList } from '@/api/demo/commodity/index'

import jumpType2 from '@/components/jumpType/jumpType.vue'
import {
  addPrintDetails,
  updateDetailList,
  getDetailList
} from '@/api/demo/imprint/index'
export default {
  name: 'discountAdd',
  components: {
    jumpType2
  },
  data () {
    var valiIcon = (rule, value, callback) => { // 图片验证
      if (!this.hasFmt) {
        callback(new Error('请上传图片'))
      } else {

      }
    }
    return {
      tableKey: 0,
      fileList: [],
      fileList1: [],
      form: {
        name: null, // 名称
        showType: null, // 展示方式
        type: null, // 类型
        checkedIcon: null, // 选中图标
        icon: '', // 图标
        products: [],
        status: '',
        articleLists: [{ // 添加文章列表
          name: '',
          img: '',
          sort: '',
          Jumpurl: {
            url: null,
            id: null,
            classId: null,
            paramType: '0',
            value: ''
          },
          fileListCover: []
        }]
      },
      goodsIds: [], // 商品分类
      statusList: [
        {
          index: 0,
          name: '下架'
        },
        {
          index: 1,
          name: '上架'
        }
      ],
      showTypeList: [
        {
          index: 0,
          name: '全屏'
        },
        {
          index: 1,
          name: '横图'
        },
        {
          index: 2,
          name: '竖图'
        }
      ],
      typeList: [
        {
          index: 0,
          name: '亲密印记'
        },
        {
          index: 1,
          name: '关系发展'
        },
        {
          index: 2,
          name: '礼物'
        },
        {
          index: 3,
          name: '首发'
        },
        {
          index: 4,
          name: '产品资讯'
        }
      ],
      rules: {
        name: [
          {
            required: true,
            message: '请输入名称',
            trigger: 'blur'
          },
          {
            min: 1,
            max: 20,
            message: '长度在 1 到 20 个字符',
            trigger: 'blur'
          }
        ],
        showType: [
          {
            required: true,
            message: '请选择展示方式',
            trigger: 'change'
          }
        ],
        type: [
          {
            required: true,
            message: '请选择类型',
            trigger: 'change'
          }
        ],
        sort: [
          {
            required: true,
            message: '请输入排序',
            trigger: 'blur'
          }
        ],
        img: [
          {
            required: true,
            message: '请上传图片',
            trigger: 'change'
          }
        ],
        Jumpurl: [
          {
            required: true,
            message: '请选择跳转类型',
            trigger: 'change'
          }
        ]
      },
      // 七牛上传图片
      uploadUrl: 'https://up-z2.qiniup.com',
      uploadData: { key: '', token: '' },
      multipleSelection: [], // 指定商品
      dataList: [],
      listQuery: {
        currentPage: 1,
        pageSize: 20,
        keyword: ''
      },
      dialogFormData: false, // 选择商品
      list: [],
      number: 0,
      total: null,

      selectSpuIds: [], // 选中的spuIds,回显数据匹配
      handleSelectedData: [], // 处理弹框选择的数据

      tablePic: '',
      fileListTable: [],

      resultArr: []
    }
  },
  computed: {
    ...mapGetters(['elements'])
  },
  created () {
    this.getId = this.$route.query.id
    if (this.getId != undefined) {
      getDetailList(this.$route.query.id).then(res => {
        this.form.articleLists = []
        res.products.forEach((item, index) => {
          let listData = []
          listData.push({
            url: item.img
          })
          this.form.articleLists.push({
            img: item.img,
            sort: item.sort,
            fileListCover: listData,
            name: item.name,
            Jumpurl: {
              url: item.skipLink,
              id: item.skipType,
              paramType: item.paramType + '',
              value: item.paramValue
            }
          })
        })
        console.log(this.form.articleLists, 'this.form.articleLists')
        // this.form = res;
        this.multipleSelection = res.products
        // res.products.forEach((item,index)=>{
        //   let fileList = []
        //   var imgList = this.multipleSelection[index].img
        //   fileList.push({url:imgList})
        //   this.$set(this.multipleSelection[index],'fileListTable',fileList)
        // })
        this.form.showType = res.showType
        this.form.status = res.status
        this.form.type = res.type
        this.form.name = res.name
        this.fileList.push({
          url: res.checkedIcon
        })
        this.fileList1.push({
          url: res.icon
        })
        this.form.checkedIcon = this.fileList[0].url
        this.form.icon = this.fileList1[0].url
      })
    } else {

    }
  },
  watch: {
    $route (to, from) {
      this.getList()
    }
  },
  mounted () {
    let that = this
    getToken({}).then(res => {
      that.uploadData.token = res.token
      that.https = res.domain
    })
  },
  methods: {
    // 查询列表
    getList () {
      let that = this
      that.listLoading = true
      getSpuList(that.listQuery).then(res => {
        that.list = res.records
        that.total = parseInt(res.total)
        that.listLoading = false
        if (this.multipleSelection) {
          this.$nextTick(() => {
            this.$refs.multipleTable.clearSelection()
            this.selectSpuIds = this.multipleSelection.map(item => item.spuId)
            res.records.forEach(item => {
              if (this.selectSpuIds.includes(item.id)) {
                this.$refs.multipleTable.toggleRowSelection(item, true)
              }
            })
          })
        }
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.listQuery.pageSize = val
      this.getList()
    },
    // 当前页
    handleCurrentChange (val) {
      this.listQuery.currentPage = val
      this.getList()
    },
    selectType (e) {
      this.form.type = e
    },
    selectStatus (e) {
      this.form.status = e
    },
    selectShowType (e) {
      this.form.showType = e
    },
    // 七牛上传图片
    handleAvatarSuccess (res, file) {
      let that = this
      that.form.checkedIcon = that.https + '/' + res.key
    },
    // 处理表格图片
    handleTablePic (res, file, row) {
      let that = this
      this.$set(row, 'img', that.https + '/' + res.key)
      // row.fileListTable[0].url = that.https + "/" + res.key
    },
    handleCoverSuccess (res, file, item, index) {
      let that = this
      item.img = that.https + '/' + res.key
      this.hasFmt = true
      this.$refs.form.validate()
    },
    onChange (file, fileList) {
    },
    // 详情图
    handleCommonIcon (res, file) {
      let that = this
      that.form.icon = that.https + '/' + res.key
    },
    // 选择商品
    getCommodity () {
      this.dialogFormData = true
      // this.$refs.multipleTable.toggleRowSelection(checked,true)
      this.getList()
    },
    // 取消
    getRem () {
      this.dialogFormData = false
      this.$refs.multipleTable.clearSelection()
    },
    // 弹窗的确定
    getData () {
      this.dialogFormData = false
      // this.multipleSelection = []

      if (this.multipleSelection == '') {
        this.handleSelectedData.forEach(item => {
          this.multipleSelection.push({
            spuId: item.id,
            spuName: item.title,
            img: item.cover
          })
        })
      } else {
        this.handleSelectedData.map(item => {
          this.multipleSelection.push({
            spuId: item.id,
            spuName: item.title,
            img: item.cover
          })
        })
      }
      this.$nextTick(function () {
        var result = []
        var obj = {}
        // 数组去重
        for (var i = 0; i < this.multipleSelection.length; i++) {
          if (!obj[this.multipleSelection[i].spuId]) {
            result.push(this.multipleSelection[i])
            obj[this.multipleSelection[i].spuId] = true
          }
        }
        this.multipleSelection = result
      })
      for (let index = 0; index < this.multipleSelection.length; index++) {
        this.goodsIds.push(this.multipleSelection[index].id)
      }
    },
    clickRow (row) {
      this.$refs.multipleTable.toggleRowSelection(row)
    },
    // 搜索
    getSearch () {
      this.getList()
    },
    // 重置
    getReset () {
      this.listQuery.keyword = ''
      this.getList()
    },
    // 批量删除
    async batchDelete () {
      if (this.multipleSelection.length <= 0) { return this.$message.error('请选择需要进行删除的商品') }
      const confirmFlag = await this.$confirm('确认删除选中的商品?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch(err => err)
      if (confirmFlag === 'cancel') return false
      // 删除取差集
      const diff = this.multipleSelection.filter(item =>
        this.dataList.every(subItem => subItem.spuId !== item.spuId)
      )
      this.multipleSelection = diff
      let arrList = []
      for (let index = 0; index < this.multipleSelection.length; index++) {
        arrList.push(this.multipleSelection[index].spuId)
      }
      this.goodsIds = arrList
      this.$message.success('删除成功')
    },
    handleSelectionChange (val) {
      this.handleSelectedData = []
      this.handleSelectedData = val
      this.number = this.handleSelectedData.length
    },
    handleDeleteChange (val) {
      this.dataList = val
    },
    beforeAvatarUpload (file) {
      const isPNG = file.type === 'image/png'
      const isJPEG = file.type === 'image/jpeg'
      const isJPG = file.type === 'image/jpg'
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isPNG && !isJPEG && !isJPG) {
        this.$message.error('上传头像图片只能是 jpg、png、jpeg 格式!')
        return false
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
        return false
      }
      this.uploadData.key = `upload_pic_${new Date().getTime()}_${file.name}`
    },
    uploadError (err, file) {
      this.$message({
        message: '上传出错，请重试！',
        type: 'error',
        center: true
      })
    },
    handleRemove (file, filelist, row) {
      row.img = ''
    },
    // 新增优惠券
    getCreate (ruleForm) {
      let that = this
      this.form.products = []
      this.form.articleLists.forEach(item => {
        this.form.products.push({
          img: item.img,
          sort: item.sort,
          paramType: item.Jumpurl.paramType,
          paramValue: item.Jumpurl.value,
          skipType: item.Jumpurl.id,
          skipLink: item.Jumpurl.url,
          name: item.name
        })
        // if(item.img != '' || item.img != undefined){
        //   this.hasFmt = true
        // }else{
        //   this.hasFmt = false
        // }
      })
      // for (let index = 0; index < that.form.products.length; index++) {
      //   if (that.form.products[index].paramType == undefined) {
      //     that.$notify({
      //       title: "提示",
      //       message: "请选择跳转类型",
      //       type: "error",
      //       duration: 2000
      //     });
      //     return false;
      //   }
      // }
      this.$refs[ruleForm].validate(valid => {
        if (valid) {
          if (this.$route.query.id != undefined) {
            updateDetailList(this.$route.query.id, this.form).then(res => {
              that.$notify({
                title: '成功',
                message: '修改成功',
                type: 'success',
                duration: 2000
              })
              that.$router.push('/demo/Imprint')
            })
          } else {
            addPrintDetails(this.form).then(res => {
              that.$notify({
                title: '成功',
                message: '新增成功',
                type: 'success',
                duration: 2000
              })
              that.$router.push('/demo/Imprint')
            })
          }
        } else {
          return false
        }
      })
    },
    // 取消
    cancel (formName) {
      this.$router.push('/demo/Imprint')
    },
    tableDbEdit (row, column, cell, event) {
      const that = this
      if (column.label == '排序') {
        event.target.innerHTML = ''
        let cellInput = document.createElement('input')
        cellInput.value = ''
        cellInput.setAttribute('type', 'text')
        cellInput.style.width = '80%'
        // cellInput.style.borderRadius = '10px'
        cell.appendChild(cellInput)
        cellInput.focus()
        cellInput.onblur = function () {
          cell.removeChild(cellInput)
          event.target.innerHTML = cellInput.value
          that.$set(row, 'sort', event.target.innerHTML)
        }
      }
    },
    addList () {
      this.form.articleLists.push({
        sort: this.form.articleLists.length + 1,
        name: '',
        img: '',
        fileListCover: [],
        Jumpurl: {
          url: null,
          id: null,
          classId: null,
          paramType: '0',
          value: ''
        },
        paramType: 0
      })
    },
    removeList (i) {
      console.log(i)
      this.form.articleLists.splice(i, 1)
      this.form.articleLists.forEach((item, index) => {
        item.sort = index + 1
      })
    }
  }
}
</script>
<style scoped>
.footer {
  text-align: center;
  margin-top: 30px;
}
.el-dialog__footer {
  display: flex;
}
/deep/ input {
  /* border-radius: 10px; */
}
.icons {
  font-size: 24px;
  position: absolute;
  top: 45%;
  left: 47%;
  transform: translateX(-50%) translateY(-50%);
  color: red;
  display: none;
}
.imgs:hover .icons {
  transform: scale(0) 0.5;
  display: block;
}
.tc {
  text-align: center;
}
.mb-20 {
  margin-bottom: 20px !important;
}
</style>
